<p-toast></p-toast>

<app-navbar />
<div class="min-h-screen">
  <router-outlet />
</div>

<app-footer />
